import FixedAssetAPI from './_fixedAssetApi.js';
import httpClient from '@/apis/base/httpclient';
class FADepreciationAPI extends FixedAssetAPI {
  constructor() {
    super();
  }
  controllerName = 'FaDepreciations';
  /**
   * Hàm sinh dữ liệu hạch toán
   * ncquyen 13/12/2022
   */
  getGenerateFADepreciation(payload) {
    let request = {
      url: this.getAPIUrl() + `/GenerateFADepreciation?currentDate=${payload.Data}`,
      data: payload,
    };
    return httpClient.postAsync(request);
  }
}

export default new FADepreciationAPI();
